import { render, staticRenderFns } from "./adminPropertiesPage.vue?vue&type=template&id=0932a0ce&scoped=true&"
import script from "./adminPropertiesPage.vue?vue&type=script&lang=js&"
export * from "./adminPropertiesPage.vue?vue&type=script&lang=js&"
import style0 from "./adminPropertiesPage.vue?vue&type=style&index=0&id=0932a0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0932a0ce",
  null
  
)

export default component.exports